module.exports = __webpack_public_path__ + "static/img/gri_980039_b07_f04_032_mm.63ac06c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/gri_980039_b07_f04_032_mm.jpg
// module id = xRLv
// module chunks = 0